//Aria hidden
 (function () {
    const FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

    function disableFocus(slide) {
      slide.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (!el.hasAttribute('data-slide-tabindex')) {
          // Persist original value (empty string = attribute wasn't set)
          el.setAttribute('data-slide-tabindex', el.getAttribute('tabindex') ?? '');
        }
        el.setAttribute('tabindex', '-1');
      });
    }

    function enableFocus(slide) {
      slide.querySelectorAll(FOCUSABLE).forEach(function (el) {
        var saved = el.getAttribute('data-slide-tabindex');
        if (saved === null) return; // We never touched this element
        saved === ''
          ? el.removeAttribute('tabindex')
          : el.setAttribute('tabindex', saved);
        el.removeAttribute('data-slide-tabindex');
      });
    }

    function update(slide) {
      slide.getAttribute('aria-hidden') === 'true'
        ? disableFocus(slide)
        : enableFocus(slide);
    }

    document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
      update(slide); // Handle slides already marked hidden on page load

      new MutationObserver(function () {
        update(slide);
      }).observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  })();

  //Aria hiddne trigger
  (function () {
    function fix(shadowRoot) {
      shadowRoot.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
        // Fix the element itself
        if (el.getAttribute('tabindex') === '0') {
          el.setAttribute('tabindex', '-1');
        }
        // Fix any focusable descendants inside the aria-hidden element
        el.querySelectorAll(
          'a[href], button, input, select, textarea, [tabindex="0"]'
        ).forEach(function (child) {
          child.setAttribute('tabindex', '-1');
        });
      });
    }

    function attachToHost(host) {
      var shadow = host.shadowRoot;
      if (!shadow) return;

      fix(shadow);

      // Watch for any future dynamic changes inside the shadow root
      new MutationObserver(function () {
        fix(shadow);
      }).observe(shadow, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'tabindex']
      });
    }

    function init() {
      var host = document.querySelector('trigger-host');
      if (host) {
        attachToHost(host);
        return true;
      }
      return false;
    }

    // Widget may load after the page — watch for it being injected
    if (!init()) {
      var bodyObserver = new MutationObserver(function (mutations, obs) {
        if (init()) obs.disconnect();
      });
      bodyObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();
  //h1
  (function () {
    // Do nothing if an H1 already exists and has text
    var existing = document.querySelector('h1');
    if (existing && existing.textContent.trim() !== '') return;

    // document.title automatically decodes HTML entities (&amp; → &)
    var titleText = document.title;

    // Strip the site name — split on common separators and take the most descriptive part
    var separators = [' | ', ' - ', ' — ', ' – ', ' :: '];
    for (var i = 0; i < separators.length; i++) {
      if (titleText.indexOf(separators[i]) !== -1) {
        var parts = titleText.split(separators[i]);
        // Use whichever part is longer (usually the descriptive page-specific part)
        titleText = parts.reduce(function (a, b) {
          return b.trim().length > a.trim().length ? b : a;
        }).trim();
        break;
      }
    }

    var h1 = document.createElement('h1');
    h1.textContent = titleText;

    // Visually hidden — invisible to sighted users, fully readable by screen readers
    h1.setAttribute('style', [
      'position: absolute',
      'width: 1px',
      'height: 1px',
      'padding: 0',
      'margin: -1px',
      'overflow: hidden',
      'clip: rect(0, 0, 0, 0)',
      'white-space: nowrap',
      'border: 0'
    ].join('; '));

    // Inject as the very first child of <main>, falling back to <body>
    var target = document.querySelector('main') || document.body;
    target.insertBefore(h1, target.firstChild);
  })();
  //Alt on product images
  (function () {
    function fixProductImageAlts() {
      document.querySelectorAll('.grid__item.grid-product').forEach(function (card) {

        // Get the product title from the card
        var titleEl = card.querySelector('.grid-product__title');
        if (!titleEl) return;

        var title = titleEl.textContent.trim();
        if (!title) return;

        // Target only images with missing or empty alt
        card.querySelectorAll('img:not([alt]), img[alt=""]').forEach(function (img) {
          var isSecondary = img.closest('.grid-product__secondary-image') !== null;

          img.setAttribute(
            'alt',
            isSecondary ? title + ' - alternate view' : title
          );
        });
      });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixProductImageAlts);
    } else {
      fixProductImageAlts();
    }

    // Re-run for dynamically injected cards (infinite scroll, AJAX filtering)
    new MutationObserver(function (mutations) {
      var affected = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            (node.matches && node.matches('.grid__item.grid-product')) ||
            (node.querySelector && node.querySelector('.grid__item.grid-product'))
          ) {
            affected = true;
          }
        });
      });
      if (affected) fixProductImageAlts();
    }).observe(document.body, { childList: true, subtree: true });
  })();

  //Pagination
  // ============================================================
// Stamped.io Pagination Accessibility Fix
// Adds aria-labels, keyboard support, and focus management
// Uses MutationObserver to survive Stamped re-renders
// ============================================================

(function () {
  'use strict';

  // ── Helpers ────────────────────────────────────────────────

  function getCurrentPage() {
    const active = document.querySelector(
      '.stamped-pagination-page.is-active'
    );
    if (!active) return 1;
    return parseInt(active.textContent.trim(), 10) || 1;
  }

  function labelPaginationAnchor(a, label) {
    a.setAttribute('aria-label', label);

    // Stamped uses onclick + no href — make it keyboard-reachable
    if (!a.getAttribute('href')) {
      a.setAttribute('href', 'javascript:void(0)'); // eslint-disable-line no-script-url
    }

    // Keyboard: fire the same onclick handler on Enter/Space
    if (!a.dataset.a11yKeyboard) {
      a.dataset.a11yKeyboard = 'true';
      a.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          a.click();
        }
      });
    }
  }

  // ── Core fix ───────────────────────────────────────────────

  function fixStampedPagination() {
    const container = document.querySelector('.stamped-pagination');
    if (!container) return;

    const currentPage = getCurrentPage();

    // -- Previous button
    const prevAnchor = container.querySelector(
      '#stamped-pagination-prev a, .stamped-pagination-prev a'
    );
    if (prevAnchor) {
      labelPaginationAnchor(prevAnchor, 'Go to previous page');
    }

    // -- Next button
    const nextAnchor = container.querySelector(
      '#stamped-pagination-next a, .stamped-pagination-next a'
    );
    if (nextAnchor) {
      labelPaginationAnchor(nextAnchor, 'Go to next page');
    }

    // -- Numbered pages
    const pageSpans = container.querySelectorAll('.stamped-pagination-page');
    pageSpans.forEach(function (span) {
      const isActive = span.classList.contains('is-active');

      if (isActive) {
        // Active page: no anchor — wrap content in a span with aria context
        span.setAttribute('aria-current', 'page');
        span.setAttribute('aria-label', 'Page ' + currentPage + ', current page');
        // Make focusable so keyboard users can orient themselves
        if (!span.hasAttribute('tabindex')) {
          span.setAttribute('tabindex', '0');
        }
      } else {
        const a = span.querySelector('a');
        if (a) {
          const pageNum = a.getAttribute('data-page') || a.textContent.trim();
          if (pageNum) {
            labelPaginationAnchor(a, 'Go to page ' + pageNum);
          }
        }
      }
    });

    // -- Wrap the whole nav in a <nav> landmark (if not already)
    const parent = container.closest('nav[aria-label]');
    if (!parent) {
      // Can't wrap in-place easily, so apply role + label to the container itself
      if (!container.getAttribute('role')) {
        container.setAttribute('role', 'navigation');
      }
      if (!container.getAttribute('aria-label')) {
        container.setAttribute('aria-label', 'Reviews pagination');
      }
    }
  }

  // ── MutationObserver (survives Stamped re-renders) ─────────

  function observeStamped() {
    // Watch the closest stable ancestor — usually #stamped-reviews-widget
    // or the reviews section container. Fall back to body if needed.
    const target =
      document.querySelector('#stamped-reviews-widget') ||
      document.querySelector('.stamped-main-widget') ||
      document.body;

    const observer = new MutationObserver(function (mutations) {
      const relevant = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.classList.contains('stamped-pagination') ||
              node.querySelector('.stamped-pagination'))
          );
        });
      });

      if (relevant) {
        // Small delay — let Stamped finish its own DOM updates
        setTimeout(fixStampedPagination, 50);
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  // ── Init ───────────────────────────────────────────────────

  function init() {
    fixStampedPagination(); // Run immediately on load
    observeStamped();       // Re-run after every Stamped re-render
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//filter
(function () {
  'use strict';

  /* ── FIX A: CSS OVERRIDE ─────────────────────────────────────────────────
     Forces .tag__input to use the clip-based visually-hidden pattern.
     !important is required to beat theme-level specificity.
  ────────────────────────────────────────────────────────────────────────── */
  var styleEl = document.createElement('style');
  styleEl.id = 'a11y-filter-checkbox-patch';
  styleEl.textContent =
    '.filter-form .tag__input,' +
    '#CollectionSidebar .tag__input,' +
    '#FilterDrawer .tag__input {' +
      'display:     block         !important;' +  /* undo display:none       */
      'visibility:  visible       !important;' +  /* undo visibility:hidden  */
      'opacity:     1             !important;' +  /* undo opacity:0          */
      'position:    absolute      !important;' +
      'width:       1px           !important;' +
      'height:      1px           !important;' +
      'padding:     0             !important;' +
      'margin:      -1px          !important;' +
      'overflow:    hidden        !important;' +
      'clip:        rect(0,0,0,0) !important;' +  /* visually hidden via clip */
      'white-space: nowrap        !important;' +
      'border:      0             !important;' +
    '}';

  (document.head || document.documentElement).appendChild(styleEl);

  /* ── FIX B: aria-label PATCH ─────────────────────────────────────────────
     Skips inputs that already carry aria-label (set by the Liquid template).
     Only fires as a fallback when a node arrives without one.
  ────────────────────────────────────────────────────────────────────────── */
  function patchInput(input) {
    if (input.getAttribute('aria-label')) return; // already labelled — skip

    var label = input.closest('label');
    if (!label) return;

    var tagText = label.querySelector('.tag__text');
    if (!tagText) return;

    /* Walk up to the immediate parent span to capture "Label (count)" */
    var outer = tagText.parentElement;
    var name = (outer && outer !== label)
      ? outer.textContent.replace(/\s+/g, ' ').trim()  // e.g. "Fitted (8)"
      : tagText.textContent.trim();

    if (name) input.setAttribute('aria-label', name);
  }

  function patchAll() {
    document.querySelectorAll(
      '.filter-form .tag__input,' +
      '#CollectionSidebar .tag__input,' +
      '#FilterDrawer .tag__input'
    ).forEach(patchInput);
  }

  /* ── FIX C: MUTATIONOBSERVER (AJAX filter updates) ───────────────────────
     Watches for DOM nodes added by AJAX filter re-renders and re-patches.
  ────────────────────────────────────────────────────────────────────────── */
  new MutationObserver(function (mutations) {
    var hit = mutations.some(function (mutation) {
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        var node = mutation.addedNodes[i];
        if (
          node.nodeType === 1 &&
          node.querySelector &&
          node.querySelector('.tag__input')
        ) {
          return true;
        }
      }
      return false;
    });
    if (hit) patchAll();
  }).observe(document.body, { childList: true, subtree: true });

  /* ── INIT ─────────────────────────────────────────────────────────────────
     requestAnimationFrame defers past theme-init scripts that run at
     DOMContentLoaded, ensuring we patch after any initial DOM manipulation.
  ────────────────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(patchAll);
    });
  } else {
    requestAnimationFrame(patchAll);
  }

}());
//Bogos
(function () {
  'use strict';
 
  var CONFIG = {
    // Heading level for each widget's title (e.g. "G Sprout Mandala
    // Bundle"). Check the surrounding page's heading structure
    // (h1 = product title, etc.) and adjust so levels stay sequential.
    titleHeadingLevel: '3',
    // Visually-hidden class used to add "Sale price:" / "Regular
    // price:" context before the two price spans. Set to null to
    // skip this enhancement.
    visuallyHiddenClass: 'visually-hidden',
  };
 
  function warn(err) {
    if (window.console) console.warn('BOGOS a11y patch:', err);
  }
 
  function text(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
 
  function bindKeyActivation(el, handler) {
    if (el.dataset.a11yBound) return;
    el.dataset.a11yBound = 'true';
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        handler();
      }
    });
  }
 
  function enhanceWidget(widget) {
    if (!widget.dataset.a11yPatched) {
      widget.dataset.a11yPatched = 'true';
 
      var titleEl = widget.querySelector('.bogos-mix-match-widget-title');
      var titleText = text(titleEl);
      if (titleText) {
        widget.setAttribute('role', 'region');
        widget.setAttribute('aria-label', titleText);
        if (titleEl) {
          titleEl.setAttribute('role', 'heading');
          titleEl.setAttribute('aria-level', CONFIG.titleHeadingLevel);
        }
      }
 
      widget.querySelectorAll('.bogos-mix-match-badge-icon svg').forEach(function (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      });
    }
 
    enhanceItems(widget);
  }
 
  function enhanceItems(widget) {
    widget.querySelectorAll('.bogos-mix-item-container').forEach(function (item) {
      var productName = text(item.querySelector('.bogos-mix-item-title')) || 'this item';
 
      var checkbox = item.querySelector('.bogos-mix-item-checkbox');
      if (checkbox) {
        checkbox.setAttribute('aria-label', 'Include ' + productName + ' in bundle');
      }
 
      var qtyInput = item.querySelector('.bogos-mix-match-quantity-input');
      if (qtyInput) {
        qtyInput.setAttribute('aria-label', 'Quantity for ' + productName);
      }
      var minusBtn = item.querySelector('.bogos-minus-mix-btn');
      if (minusBtn) {
        minusBtn.setAttribute('aria-label', 'Decrease quantity for ' + productName);
      }
      var plusBtn = item.querySelector('.bogos-plus-mix-btn');
      if (plusBtn) {
        plusBtn.setAttribute('aria-label', 'Increase quantity for ' + productName);
      }
 
      var oos = item.querySelector('.bogos-mix-item-out-stock');
      if (oos) {
        oos.setAttribute('role', 'status');
      }
 
      var chooseProduct = item.querySelector('.bogos-mix-item-choose-product');
      if (chooseProduct) {
        chooseProduct.setAttribute('role', 'button');
        chooseProduct.setAttribute('tabindex', '0');
        bindKeyActivation(chooseProduct, function () {
          chooseProduct.click();
        });
      }
 
      enhanceVariantDropdown(item, productName);
      enhancePriceLabels(item);
    });
  }
 
  function enhanceVariantDropdown(item, productName) {
    var dropdown = item.querySelector('.bogos-mix-item-select-variant-dropdown');
    if (!dropdown) return;
 
    var trigger = dropdown.querySelector('.bogos-mix-item-select-variant-title-contain');
    var currentLabelEl = dropdown.querySelector('.bogos-mix-item-select-variant-title');
    var listbox = dropdown.querySelector('.bogos-mix-item-select-variant-options');
    var options = dropdown.querySelectorAll('.bogos-mix-item-select-variant-option');
    var currentVariantId = currentLabelEl ? currentLabelEl.getAttribute('data-variant-id') : null;
 
    if (trigger) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-label', 'Choose size for ' + productName);
      bindKeyActivation(trigger, function () {
        trigger.click();
      });
    }
 
    if (listbox) {
      listbox.setAttribute('role', 'listbox');
      listbox.setAttribute('aria-label', 'Available sizes for ' + productName);
    }
 
    options.forEach(function (opt) {
      opt.setAttribute('role', 'option');
      opt.setAttribute('tabindex', '0');
 
      if (opt.getAttribute('data-option-available') === '0') {
        opt.setAttribute('aria-disabled', 'true');
      } else {
        opt.removeAttribute('aria-disabled');
      }
 
      var isSelected = !!currentVariantId && opt.getAttribute('data-variant-id') === currentVariantId;
      opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
 
      bindKeyActivation(opt, function () {
        opt.click();
      });
    });
  }
 
  function enhancePriceLabels(item) {
    if (!CONFIG.visuallyHiddenClass) return;
 
    var priceWrap = item.querySelector('.bogos-mix-item-price');
    if (!priceWrap || priceWrap.dataset.a11yPriceLabelled) return;
    priceWrap.dataset.a11yPriceLabelled = 'true';
 
    var discount = priceWrap.querySelector('.bogos-mix-item-discount-price');
    var original = priceWrap.querySelector('.bogos-mix-item-original-price');
 
    if (discount) prependLabel(discount, 'Sale price: ');
    if (original) prependLabel(original, 'Regular price: ');
  }
 
  function prependLabel(el, labelText) {
    var span = document.createElement('span');
    span.className = CONFIG.visuallyHiddenClass;
    span.textContent = labelText;
    el.insertBefore(span, el.firstChild);
  }
 
  function scan(root) {
    try {
      if (!root.querySelectorAll) return;
      if (root.classList && root.classList.contains('bogos-mix-match-widget')) {
        enhanceWidget(root);
      }
      root.querySelectorAll('.bogos-mix-match-widget').forEach(enhanceWidget);
    } catch (err) {
      warn(err);
    }
  }
 
  function init() {
    scan(document);
 
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        } else if (m.type === 'attributes') {
          try {
            var item = m.target.closest && m.target.closest('.bogos-mix-item-container');
            if (item) {
              enhanceVariantDropdown(item, text(item.querySelector('.bogos-mix-item-title')) || 'this item');
            }
          } catch (err) {
            warn(err);
          }
        }
      });
    });
 
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-variant-id', 'data-option-available'],
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

//Variants
/**
 * grc-variant-a11y.js
 * Grassroots California – Variant Selector Accessibility Fixes
 *
 * Fixes two issues on product pages:
 *   1. Fieldset <legend> hidden with display:none → screen readers can't
 *      announce "Color", "Size", etc. as group context before each option.
 *   2. Out-of-stock radio inputs have no accessible cue — only a visual
 *      .disabled CSS class — so screen readers give no "Out of stock" signal.
 *
 * HOW TO ADD THIS TO YOUR SHOPIFY THEME
 * ─────────────────────────────────────
 * Option A (recommended) — inline snippet:
 *   1. In Shopify Admin → Online Store → Themes → Edit code
 *   2. Open layout/theme.liquid
 *   3. Paste the contents of this file inside a <script> tag just before </body>
 *
 * Option B — separate asset file:
 *   1. Upload this file to Assets as grc-variant-a11y.js
 *   2. In theme.liquid before </body>, add:
 *      {{ 'grc-variant-a11y.js' | asset_url | script_tag }}
 *
 * The script is safe to load on every page — it does nothing if the variant
 * selector markup is not present.
 */

(function () {
  'use strict';

  // ─── CSS.escape polyfill for browsers that don't have it ──────────────────
  // Needed to safely query-select IDs that contain URL-encoded chars like %2F
  if (!window.CSS || !CSS.escape) {
    CSS.escape = function (value) {
      return String(value).replace(/([^\w-])/g, '\\$1');
    };
  }

  // ─── 1. Inject the visually-hidden utility class ──────────────────────────
  //
  // The theme's .hide class most likely uses display:none, which removes
  // content from both the visual layout AND the accessibility tree.
  // .grc-sr-only keeps the element out of visual flow while remaining
  // fully available to screen readers.
  function injectStyles() {
    if (document.getElementById('grc-a11y-styles')) return;
    var el = document.createElement('style');
    el.id = 'grc-a11y-styles';
    el.textContent =
      '.grc-sr-only{' +
        'position:absolute!important;' +
        'width:1px!important;' +
        'height:1px!important;' +
        'padding:0!important;' +
        'margin:-1px!important;' +
        'overflow:hidden!important;' +
        'clip:rect(0,0,0,0)!important;' +
        'white-space:nowrap!important;' +
        'border:0!important' +
      '}';
    document.head.appendChild(el);
  }

  // ─── 2. Fix fieldset <legend> elements ───────────────────────────────────
  //
  // Screen-reader behaviour for a <fieldset>/<legend> group:
  //   When focus enters a radio inside the fieldset, SRs announce:
  //   "[legend text], [radio label], radio button, 1 of 1"
  //
  // Two problems exist in the current markup:
  //   a) <legend class="hide"> — if .hide === display:none the legend is
  //      invisible to assistive tech. We swap the class for .grc-sr-only.
  //   b) <label for="fieldset-id"> — <label> can only programmatically
  //      associate with form controls, not fieldsets. Most SRs ignore or
  //      mishandle it. We mark it aria-hidden to prevent double-reading,
  //      since the <legend> now carries the group name.
  //
  // Belt-and-suspenders: we also write aria-label on the <fieldset> directly
  // because some older screen reader / browser combos skip <legend> entirely.
  function fixLegends() {
    document.querySelectorAll('.variant-wrapper').forEach(function (wrapper) {
      var visibleLabel = wrapper.querySelector('.variant__label');
      var fieldset = wrapper.querySelector('fieldset.variant-input-wrap');
      if (!visibleLabel || !fieldset) return;

      var groupName = visibleLabel.textContent.trim();

      // Find or create the <legend> as first child of the fieldset
      var legend = fieldset.querySelector('legend');
      if (!legend) {
        legend = document.createElement('legend');
        fieldset.insertBefore(legend, fieldset.firstChild);
      }

      // Swap display:none (.hide) for the accessible visually-hidden class
      legend.classList.remove('hide');
      legend.classList.add('grc-sr-only');

      // Ensure legend text matches the visible attribute label
      if (!legend.textContent.trim()) {
        legend.textContent = groupName;
      }

      // The <label for="fieldsetId"> is invalid — <label> can only associate
      // with form controls, not fieldsets. Audit tools (axe, WAVE, Lighthouse)
      // flag this as an "orphaned label" because the for target is not a
      // labelable element.
      //
      // Fix: remove the for attribute entirely (eliminating the orphan) and
      // hide the element from the accessibility tree with aria-hidden so it
      // isn't announced at all — the <legend> now carries the group name.
      var forAttr = visibleLabel.getAttribute('for');
      if (forAttr && forAttr === fieldset.id) {
        visibleLabel.removeAttribute('for');          // resolves the orphan flag
        visibleLabel.setAttribute('aria-hidden', 'true'); // skip in AT tree
      }

      // Redundant aria-label on the fieldset itself for older SR support
      if (!fieldset.hasAttribute('aria-label')) {
        fieldset.setAttribute('aria-label', groupName);
      }
    });
  }

  // ─── 3. Announce out-of-stock variants ───────────────────────────────────
  //
  // The theme marks unavailable options by adding the CSS class .disabled —
  // this is purely visual. Screen readers announce "L/XL, radio button"
  // with no indication the option is sold out.
  //
  // Fix:
  //   • aria-disabled="true" on the <input> — tells SRs the control is
  //     unavailable without removing it from focus order (Shopify's JS
  //     may still need to read / interact with these inputs, so we don't
  //     use the HTML disabled attribute which would break event handling).
  //   • Append a visually-hidden "(Out of stock)" <span> to the <label>
  //     so SRs read e.g. "L/XL (Out of stock), radio button".
  //
  // When a variant comes back in stock (Shopify removes .disabled during
  // a session) we clean up the injected markup to keep things accurate.
  function fixOutOfStock() {
    document.querySelectorAll('.variant-input input[data-variant-input]').forEach(function (input) {
      var isOOS = input.classList.contains('disabled') || input.hasAttribute('disabled');
      // Use CSS.escape because some IDs contain %2F (encoded "/" for sizes like S/M)
      var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');

      if (isOOS) {
        input.setAttribute('aria-disabled', 'true');

        if (label && !label.querySelector('.grc-oos-label')) {
          var oos = document.createElement('span');
          oos.className = 'grc-oos-label grc-sr-only';
          oos.textContent = ' (Out of stock)';
          label.appendChild(oos);
        }
      } else {
        // In-stock: remove stale OOS markers so the announcement stays accurate
        input.removeAttribute('aria-disabled');
        if (label) {
          var stale = label.querySelector('.grc-oos-label');
          if (stale) stale.remove();
        }
      }
    });
  }

  // ─── 4. Initialise ────────────────────────────────────────────────────────
  function init() {
    injectStyles();

    // fixLegends only needs to run once — the legend DOM never changes
    fixLegends();

    // fixOutOfStock runs on load, then again whenever availability changes
    fixOutOfStock();

    // ── 4a. MutationObserver: Shopify's variant JS toggles .disabled ─────
    // When a user changes a variant option the theme JS adds/removes .disabled
    // on sibling radio inputs. We watch for those attribute mutations.
    if (window.MutationObserver) {
      var fieldsets = document.querySelectorAll('.variant-input-wrap');
      if (fieldsets.length) {
        var observer = new MutationObserver(function (mutations) {
          var relevant = mutations.some(function (m) {
            return m.type === 'attributes' &&
              (m.attributeName === 'class' || m.attributeName === 'disabled');
          });
          if (relevant) fixOutOfStock();
        });
        fieldsets.forEach(function (fs) {
          observer.observe(fs, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class', 'disabled']
          });
        });
      }
    }

    // ── 4b. Custom events fired by some Shopify themes & apps ─────────────
    // Different themes and 3rd-party apps use slightly different event names.
    document.addEventListener('variant:change', fixOutOfStock);   // some themes
    document.addEventListener('variantChange', fixOutOfStock);    // Brooklyn/Debut
    document.addEventListener('product:variant-change', fixOutOfStock); // some apps
  }

  // Run after the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
//Empty Heading
(function () {
  function removeEmptyHeadings() {
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

    headings.forEach(function (heading) {
      const text = heading.textContent.replace(/\u00A0/g, ' ').trim(); // strips &nbsp; too
      const hasImage = heading.querySelector('img, svg');
      const hasIcon  = heading.querySelector('[class*="icon"], [class*="fa-"], [aria-hidden]');

      if (!text && !hasImage && !hasIcon) {
        heading.remove();
      }
    });
  }

  // ── 1. Run on initial DOM ready ──────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeEmptyHeadings);
  } else {
    removeEmptyHeadings();
  }

  // ── 2. Re-run after full page load (catches late-injected content) ──
  window.addEventListener('load', removeEmptyHeadings);

  // ── 3. Watch for 3rd-party / dynamic content added after load ──
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewNodes) removeEmptyHeadings();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
//Calendar icons

(function () {
  'use strict';

  /* ── Accessible-name check ─────────────────────────────────────────────── */
  /* Returns true if the element has at least one reliable accessible name
     source. This guards against accidentally hiding an icon that IS the
     only name the button has.                                                */
  function hasAccessibleName (el) {
    return (
      /* aria-label on the element itself */
      (el.getAttribute('aria-label')      || '').trim() !== '' ||
      /* aria-labelledby points to another element's text */
      (el.getAttribute('aria-labelledby') || '').trim() !== '' ||
      /* title attribute — FullCalendar's chosen approach for these buttons */
      (el.getAttribute('title')           || '').trim() !== '' ||
      /* visible text content (not applicable here but covers other cases) */
      el.textContent.trim()                              !== ''
    );
  }

  /* ── Core fix ──────────────────────────────────────────────────────────── */
  function fixDecorativeIcons () {
    /* Target any .fc-icon that still carries role="img" and has no name.
       Skipping elements already processed (aria-hidden already set) keeps
       the function idempotent when called repeatedly by the observer.       */
    var icons = document.querySelectorAll('.fc-icon[role="img"]:not([aria-hidden])');

    for (var i = 0; i < icons.length; i++) {
      var icon = icons[i];

      /* Walk up to the nearest interactive parent */
      var parent = icon.closest('button, [role="button"], a[href]');

      /* Only suppress the icon when the parent ALREADY has an accessible name.
         If somehow the icon's role is the only name source, leave it alone.  */
      if (!parent || !hasAccessibleName(parent)) continue;

      icon.removeAttribute('role');           /* no longer an unnamed img role  */
      icon.setAttribute('aria-hidden', 'true'); /* excluded from AT entirely   */
    }
  }

  /* ── Init ──────────────────────────────────────────────────────────────── */
  fixDecorativeIcons();

  /* ── MutationObserver — FullCalendar re-renders on every navigation ────── */
  /* FullCalendar tears down and rebuilds its toolbar HTML when the user
     clicks prev/next or switches views, so the fixed attributes are lost.
     The observer re-applies the fix whenever new nodes appear.               */
  if (window.MutationObserver) {
    var debounceTimer;

    new MutationObserver(function (mutations) {
      /* Only re-scan when actual nodes were added to the tree */
      var hasNewNodes = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' && mutations[i].addedNodes.length) {
          hasNewNodes = true;
          break;
        }
      }
      if (!hasNewNodes) return;

      /* Debounce: FullCalendar can fire many mutations in one render cycle */
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fixDecorativeIcons, 100);
    }).observe(document.body, {
      childList: true,
      subtree:   true
    });
  }

})();

//Calendar empty link
(function () {
  'use strict';

  // ── Core fix ───────────────────────────────────────────────
  // The address link is empty on load — the 3rd party app
  // populates .cali-event-address text dynamically, so we
  // watch for that text and label accordingly.

  function fixAddressLinks() {
    document.querySelectorAll('a.cali-event-address-link').forEach(function (a) {
      var small = a.querySelector('.cali-event-address');
      var address = small ? small.textContent.trim() : '';

      if (address) {
        a.setAttribute('aria-label', 'View address: ' + address + ' (opens in new tab)');
      } else {
        // Text not populated yet — set a generic fallback
        // and mark for re-check when text arrives
        if (!a.getAttribute('aria-label')) {
          a.setAttribute('aria-label', 'View event address (opens in new tab)');
        }
        a.dataset.a11yPending = 'true';
      }

      // target="_blank" always needs this warning for SR users
      // Only add rel if not already set
      if (!a.getAttribute('rel')) {
        a.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  // ── MutationObserver ───────────────────────────────────────
  // Watches for two things:
  // 1. New .cali-event-address-link elements injected by the app
  // 2. Text content changes inside existing address spans

  function observe() {
    var target = document.body;

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (m) {
        // New nodes added that contain or are address links
        var hasNewLinks = Array.from(m.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.classList.contains('cali-event-address-link') ||
              node.classList.contains('cali-event-address') ||
              (node.querySelector && (
                node.querySelector('.cali-event-address-link') ||
                node.querySelector('.cali-event-address')
              )))
          );
        });

        // Text content changed inside a pending address span
        var hasTextUpdate =
          m.type === 'characterData' &&
          m.target.parentElement &&
          m.target.parentElement.classList.contains('cali-event-address');

        // Child nodes changed inside an address span (app sets innerHTML)
        var hasChildUpdate =
          m.target &&
          m.target.classList &&
          (m.target.classList.contains('cali-event-address') ||
            m.target.classList.contains('cali-event-address-link'));

        return hasNewLinks || hasTextUpdate || hasChildUpdate;
      });

      if (shouldRun) {
        setTimeout(fixAddressLinks, 50);
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,  // catches direct text node updates
    });
  }

  // ── Init ───────────────────────────────────────────────────

  function init() {
    fixAddressLinks();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//forms
(function () {
  'use strict';

  // ── Config: map input id → accessible label ─────────────────
  // Covers every field in the form. Update if field IDs change.
  var FIELD_LABELS = {
    '764-wfFields':  'Name',
    '768-wfFields':  'Email address',
    '772-wfFields':  'Phone number',
    '776-wfFields':  'Company name',
    '780-wfFields':  'Company website',
    '784-wfFields':  'Company Address',
    '788-wfFields':  'Upload your logo. Vector art is preferred.',
    '792-wfFields':  'Upload your artwork.',
    '796-wfFields':  'What products are you interested in?',
    '800-wfFields':  'Do you understand the minimum order quantity requirement?',
    '804-wfFields':  'Tell us about your project',
    '808-wfFields':  'How did you find out about us?'
  };

  // ── 1. Standard inputs / textarea ───────────────────────────
  // Adds aria-label only where the programmatic label association
  // is broken or missing. Skips fields that already have a working
  // label so we don't double-announce.
  function fixStandardInputs(form) {
    Object.keys(FIELD_LABELS).forEach(function (id) {
      var el = form.querySelector('#' + CSS.escape(id));
      if (!el) return;
      if (el.type === 'hidden' || el.type === 'file') return;

      // Check if a <label for="id"> exists and is non-empty
      var labelEl = form.querySelector('label[for="' + CSS.escape(id) + '"]');
      var hasVisibleLabel = labelEl && labelEl.textContent.trim().length > 0;

      // For the react-select combobox, aria-describedby="placeholder"
      // is set by the library and overrides the label in some SRs.
      // Replace it with aria-labelledby pointing to the real label.
      if (el.getAttribute('role') === 'combobox') {
        if (labelEl && !labelEl.id) {
          labelEl.id = 'a11y-label-' + id;
        }
        if (labelEl && labelEl.id) {
          el.setAttribute('aria-labelledby', labelEl.id);
          el.removeAttribute('aria-describedby'); // remove placeholder ref
        } else {
          el.setAttribute('aria-label', FIELD_LABELS[id]);
        }
        // Combobox required state
        if (el.getAttribute('aria-required') === 'false' && isFieldRequired(id, form)) {
          el.setAttribute('aria-required', 'true');
        }
        return;
      }

      // For all other inputs: only add aria-label if no working label exists
      if (!hasVisibleLabel) {
        el.setAttribute('aria-label', FIELD_LABELS[id]);
      }

      // Sync required state onto the actual input (the hidden
      // required input inside <legend> doesn't help screen readers)
      if (isFieldRequired(id, form)) {
        el.setAttribute('aria-required', 'true');
        if (labelEl) annotateLabelRequired(labelEl);
      }
    });
  }

  // ── 2. File upload buttons ───────────────────────────────────
  // Structure is: <button><svg/><span>Upload</span><input type="file"></button>
  // The <input type="file"> inside a <button> is invalid HTML.
  // We can't restructure it (3rd party), so we:
  //   a) Label the button with the fieldset legend text
  //   b) Give the file input an aria-label and move it out of
  //      the button's accessible name calculation
  function fixFileUploads(form) {
    var fileMap = {
      '788-wfFields': 'Upload your logo. Vector art is preferred. Maximum size 50 MB.',
      '792-wfFields': 'Upload your artwork. Maximum size 50 MB.'
    };

    Object.keys(fileMap).forEach(function (id) {
      var input = form.querySelector('#' + CSS.escape(id));
      if (!input) return;

      var button = input.closest('button');
      if (button) {
        // Label the button so SR announces the purpose, not just "Upload"
        if (!button.getAttribute('aria-label')) {
          button.setAttribute('aria-label', fileMap[id]);
        }
      }

      // Label the file input itself for SRs that pierce into the button
      if (!input.getAttribute('aria-label')) {
        input.setAttribute('aria-label', fileMap[id]);
      }
    });
  }

  // ── 3. Required asterisk spans ───────────────────────────────
  // <span class="css-l3hif9">*</span> is visible but not SR-announced.
  // Replace with a visually identical but accessible pattern.
  function fixRequiredAsterisks(form) {
    form.querySelectorAll('.css-l3hif9').forEach(function (span) {
      if (span.dataset.a11yFixed) return;
      // Hide the visual * from SR and add a SR-only text instead
      span.setAttribute('aria-hidden', 'true');
      // Insert SR-only sibling
      var srSpan = document.createElement('span');
      srSpan.className = 'a11y-required-sr-only';
      srSpan.textContent = '(required)';
      span.insertAdjacentElement('afterend', srSpan);
      span.dataset.a11yFixed = 'true';
    });
  }

  // ── 4. Checkbox groups ───────────────────────────────────────
  // The required hidden input inside <legend> is read by some SRs.
  // Also ensure each checkbox has a computed label via its wrapping <label>.
  function fixCheckboxGroups(form) {
    form.querySelectorAll('fieldset').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;

      // Hide the hidden required input from the AT entirely
      var hiddenReqInput = legend.querySelector('input[aria-hidden="true"]');
      if (hiddenReqInput) {
        hiddenReqInput.setAttribute('aria-hidden', 'true'); // already set, ensure
        hiddenReqInput.setAttribute('tabindex', '-1');      // already set, ensure
      }

      // Mark the fieldset required if it contains a required indicator
      var hasRequired = legend.querySelector('.css-l3hif9') !== null;
      if (hasRequired && !fs.getAttribute('aria-required')) {
        fs.setAttribute('aria-required', 'true');
      }

      // Ensure each checkbox label is non-empty
      fs.querySelectorAll('label').forEach(function (lbl) {
        var cb = lbl.querySelector('input[type="checkbox"]');
        if (!cb) return;
        var text = lbl.textContent.trim();
        if (text && !cb.getAttribute('aria-label')) {
          // Label is computed correctly via wrapping <label> — no action needed
          // But add aria-label as a belt-and-suspenders fallback
          cb.setAttribute('aria-label', text);
        }
      });
    });
  }

  // ── 5. Submit button ─────────────────────────────────────────
  // value="Submit" is fine but adding form context helps SR users
  // who may have multiple forms on the page.
  function fixSubmitButton(form) {
    var submit = form.querySelector('input[type="submit"]');
    if (submit && !submit.getAttribute('aria-label')) {
      submit.setAttribute('aria-label', 'Submit Custom Merchandise Inquiry');
    }
  }

  // ── 6. hCaptcha hidden textareas ─────────────────────────────
  // display:none removes from AT already, but belt-and-suspenders:
  function fixCaptchaElements(form) {
    ['g-recaptcha-response-0gqiol9q3ul7', 'h-captcha-response-0gqiol9q3ul7'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
      }
    });
    // Submission ID field
    var subId = form.querySelector('input[name="submission-id-wffield-92"]');
    if (subId) {
      subId.setAttribute('aria-hidden', 'true');
    }
  }

  // ── Helpers ──────────────────────────────────────────────────

  function isFieldRequired(id, form) {
    var el = form.querySelector('#' + CSS.escape(id));
    if (!el) return false;
    if (el.hasAttribute('required')) return true;
    // Check for the asterisk in the associated label/legend
    var label = form.querySelector('label[for="' + CSS.escape(id) + '"]');
    if (label && label.querySelector('.css-l3hif9')) return true;
    return false;
  }

  function annotateLabelRequired(labelEl) {
    if (labelEl.dataset.a11yRequired) return;
    // Only add SR text if not already present
    if (!labelEl.querySelector('.a11y-required-sr-only')) {
      var srSpan = document.createElement('span');
      srSpan.className = 'a11y-required-sr-only';
      srSpan.textContent = ' (required)';
      labelEl.appendChild(srSpan);
    }
    labelEl.dataset.a11yRequired = 'true';
  }

  // ── Main runner ───────────────────────────────────────────────

  function fixForm(form) {
    fixStandardInputs(form);
    fixFileUploads(form);
    fixRequiredAsterisks(form);
    fixCheckboxGroups(form);
    fixSubmitButton(form);
    fixCaptchaElements(form);
  }

  function findAndFix() {
    var form = document.querySelector('form#V2j9JG, form[name="V2j9JG"]');
    if (form) fixForm(form);
  }

  // ── MutationObserver — 3rd party may render form late ────────

  function observe() {
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.id === 'V2j9JG' ||
              node.name === 'V2j9JG' ||
              (node.querySelector && node.querySelector('form#V2j9JG, form[name="V2j9JG"]')))
          );
        });
      });
      if (relevant) setTimeout(findAndFix, 50);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── CSS for SR-only required text ────────────────────────────

  function injectStyles() {
    if (document.getElementById('a11y-form-styles')) return;
    var style = document.createElement('style');
    style.id = 'a11y-form-styles';
    style.textContent = [
      '.a11y-required-sr-only {',
      '  position: absolute;',
      '  width: 1px;',
      '  height: 1px;',
      '  padding: 0;',
      '  margin: -1px;',
      '  overflow: hidden;',
      '  clip: rect(0,0,0,0);',
      '  white-space: nowrap;',
      '  border: 0;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ── Init ─────────────────────────────────────────────────────

  function init() {
    injectStyles();
    findAndFix();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
(function () {
  'use strict';

  function fixCaptchaElements() {

    // ── Target by ID (covers all widget IDs seen so far) ───────
    [
      'g-recaptcha-response-06zps1snomg',  // ← new
      'h-captcha-response-06zps1snomg',    // ← new
      'g-recaptcha-response-0uzl8tgkkmyi',
      'h-captcha-response-0uzl8tgkkmyi',
      'g-recaptcha-response-0gqiol9q3ul7',
      'h-captcha-response-0gqiol9q3ul7'
    ].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    });

    // ── Broad net: any hCaptcha textarea by name ───────────────
    // Catches future widget IDs without needing a script update
    [
      'textarea[name="g-recaptcha-response"]',
      'textarea[name="h-captcha-response"]'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  // ── MutationObserver — hCaptcha injects these asynchronously ─

  function observe() {
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.tagName === 'TEXTAREA' ||
              (node.querySelector && node.querySelector(
                'textarea[name*="captcha"], textarea[name*="recaptcha"]'
              )))
          );
        });
      });
      if (relevant) setTimeout(fixCaptchaElements, 50);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    fixCaptchaElements();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
